/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowFigureACircleUpIcon16Regular = forwardRef('ArrowFigureACircleUpIcon16Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M8 11.75a.75.75 0 0 1-.75-.75V6.572L6.076 7.98a.75.75 0 1 1-1.152-.96l1.732-2.078c.7-.84 1.989-.84 2.688 0l1.732 2.078a.75.75 0 0 1-1.152.96L8.75 6.572V11a.75.75 0 0 1-.75.75Z" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14ZM2.5 8a5.5 5.5 0 1 0 11 0 5.5 5.5 0 0 0-11 0Z" })));
});
